module.exports = __webpack_public_path__ + "img/bg_ticket.6c680103.svg";